import { useLocale } from '@/hooks/useLocale';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS, LANG_LABELS } from '@/i18n';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

export function LanguageSwitcher({ variant = 'light' }) {
  const { lang, switchLanguage } = useLocale();
  const { t } = useTranslation();
  const isDark = variant === 'dark';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={`gap-1.5 text-sm ${
            isDark ? 'text-[#8A929B] hover:text-[#FAFAFA]' : 'text-[#66707A] hover:text-[#171A1D]'
          }`}
          data-testid="language-switcher"
          aria-label={t('homepage.language')}
        >
          <Globe className="w-4 h-4" />
          <span className="uppercase font-mono text-xs">{lang}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className={isDark ? 'bg-[#181B1F] border-[#2A2F34]' : ''}
      >
        {SUPPORTED_LANGS.map((code) => (
          <DropdownMenuItem
            key={code}
            onClick={() => switchLanguage(code)}
            className={`cursor-pointer text-sm ${
              code === lang ? 'font-bold' : ''
            } ${isDark ? 'text-[#FAFAFA] focus:bg-[#181B1F] focus:text-[#FAFAFA]' : ''}`}
            data-testid={`lang-option-${code}`}
          >
            <span className="uppercase font-mono text-xs w-6">{code}</span>
            <span>{LANG_LABELS[code]}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
